module.exports = __webpack_public_path__ + "img/12_60.c5a3362f.png";